import { Box, HStack, Header, makeUclComponent } from '@rbilabs/universal-components';

import Picture from 'components/picture';
import { theme } from 'styles/configure-theme';

export const LeftColumn = Box.withConfig({
  width: '1/3',
  paddingY: '$12',
  paddingRight: {
    lg: '$7',
    base: 0,
  },
});

export const RightColumn = Box.withConfig({
  width: '2/3',
});

export const PictureStyled = makeUclComponent(Picture).withConfig({
  height: '350px',
  width: 'full',
  flex: 1,
});

export const ButtonsContainer = Box.withConfig({
  marginTop: '$6',
  maxWidth: '300px',
});

export const HeaderContainer = Box.withConfig({
  focusable: true,
  accessible: true,
  accessibilityRole: 'header',
});

export const HeaderStyled = Header.withConfig({
  color: theme.token('text-hero-light'),
  variant: 'hero',
  lineHeight: 'xs',
  fontWeight: 700,
  marginBottom: '$0',
  fontSize: {
    base: '4xl',
    md: '5xl',
    lg: '6xl',
  },
});

export const HeroSection = HStack.withConfig({
  background: 'transparent',
});
